import React from 'react';
import { useNavigate } from 'react-router-dom';
import './package-pages.css';

const PackageGracePeriodBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="package-grace-banner" role="status">
      <div className="package-grace-banner__inner">
        <p className="package-grace-banner__text">
          Your subscription has expired and is in the grace period. Renew soon to avoid losing access.
        </p>
        <button
          type="button"
          className="package-grace-banner__btn"
          onClick={() => navigate('/app/billing')}
        >
          Renew
        </button>
      </div>
    </div>
  );
};

export default PackageGracePeriodBanner;
